<div class="cm-cascade-popover">
    <div class="cm-header">
        <span class="cm-name">{{ name }}</span>
        <span class="cm-status" [class]="status.class">{{ status.label }}</span>
    </div>
    <div class="cm-mode">
        <span class="cm-mode-label">{{ platform.label }}</span>
        @let d = platform.dots;
        @if (d !== null) {
            <span class="cm-dots" aria-hidden="true">
                <span class="cm-dot" [class.cm-filled]="d >= 2"></span>
                <span class="cm-dot" [class.cm-filled]="d >= 1"></span>
            </span>
        }
    </div>
    @if (step.events.length) {
        <ol class="cm-events">
            @for (event of step.events; track $index) {
                <li class="cm-event">
                    <span class="cm-dot" [class]="categoryClass(event.category)"></span>
                    <div class="cm-event-body">
                        <div class="cm-event-head">
                            <span class="cm-event-label">{{ event.label }}</span>
                            <time class="cm-event-time">{{ event.observedAt | date: "MMM d, HH:mm:ss" }}</time>
                        </div>
                        @if (event.message) {
                            <div class="cm-event-message">{{ event.message }}</div>
                        }
                    </div>
                </li>
            }
        </ol>
    } @else {
        <div class="cm-no-events">No events on this step yet.</div>
    }
</div>
